import { render, staticRenderFns } from "./onlyForm.vue?vue&type=template&id=30713aac&scoped=true"
import script from "./onlyForm.vue?vue&type=script&lang=js"
export * from "./onlyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30713aac",
  null
  
)

export default component.exports